<script>
  import { Bar, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins;
  export default {
    name: "bar-chart",
    extends: Bar,
    props: ['options', 'width', 'height'],
    mixins: [reactiveProp],
    mounted () {
      this.renderChart(this.chartData)
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/BarChart/BarChart.vue